export default __webpack_public_path__ + "static/media/2.726fed8d.png";